export default __webpack_public_path__ + "static/media/Beard_9_C5.08b1f062.svg";